<ng-container *ngIf="loaderType == loaderTypes.TYPING">
  <div class="stage-typing">
    <img
      src="../../../../assets/animations/loader.gif"
      alt="Typing"
      class="loader-typing"
      height="42"
      width="42"
    />
    <span class="text">
      &nbsp;{{
        canvasService.isContentEditorOpened
          ? stringConstants.INLINE_LOADER_TEXT
          : canvasService.getInlineStatusUpdates()
      }}</span
    >
  </div>
</ng-container>

<ng-container *ngIf="loaderType == loaderTypes.ROBOT">
  <div class="stage-robot">
    <div
      class="svg-spinner-container"
      [class.loading]="robotStatus == loaderTypes.ROBOT_LOADING"
    >
      <svg class="spinner-svg" viewBox="0 0 36 36">
        <circle class="track" cx="18" cy="18" r="16" />
        <circle
          class="progress"
          [class.failure]="robotStatus == loaderTypes.ROBOT_ERROR"
          cx="18"
          cy="18"
          r="16"
          [attr.stroke]="
            robotStatus == loaderTypes.ROBOT_LOADING ? '#0042a6' : '#ff4236'
          "
        />
      </svg>
      <div class="spinner-icon">
        <ng-container>
          <img
            src="../../../../assets/animations/robot.gif"
            alt="Robot"
            class="loader-robot"
            height="150"
            width="200"
          />
        </ng-container>
      </div>
    </div>
    <span>{{
      robotStatus == loaderTypes.ROBOT_ERROR
        ? "Failed to load document"
        : canvasService.getRobotStatusUpdates()
    }}</span>
  </div>
</ng-container>
